import * as React from "react";
import classnames from "classnames";
import { Heading } from "@grandvisionhq/elements";
import { parseHtml } from "@grandvisionhq/lib-utils-html";
const StoreDescription = ({ className, labels, description, ...rest }) => description ? /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-description", className) }, /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2" }, labels.title), parseHtml(description)) : null;
export {
  StoreDescription as default
};
//# sourceMappingURL=StoreDescription.js.map
